import axios from "axios";
import Vue from "vue";
import Cookies from 'js-cookie'

export default {
  namespaced: true,

  state: {
    all: [],
    uniqueTitles: [],
    searchTerm: "",
    currentOpportunity: {},

    subscriptions: [],
  },

  mutations: {
    ADD_OPPORTUNITY(_state, payload) {
      const state = _state;
      // Adiciona as oportunidades do state, mas antes verifica se ela ainda não existe
      // Adiciona titles que ainda nao existem no uniqueTitles para ter um array só com titles
      payload.forEach((_opportunity) => {
        const opportunity = _opportunity;

        if (
          !state.all.find(
            (o) => o.links.subscription == opportunity.links.subscription
          )
        ) {
          const subscriptionLink = opportunity.links.subscription.split("/");
          opportunity.slug = subscriptionLink[subscriptionLink.length - 1];
          state.all.push(opportunity);

          const { uniqueTitles } = state;
          // eslint-disable-next-line no-unused-expressions
          uniqueTitles.indexOf(opportunity.title) == -1 &&
            uniqueTitles.push(opportunity.title);
        }
      });
    },

    CLEAR_OPPORTUNITIES(_state) {
      const state = _state;
      // Limpa state de oportunidades
      state.all = [];
    },

    ADD_SEARCH_JOB_TERM(_state, payload) {
      const state = _state;
      // Adiciona o termo buscado pelo usuario
      state.searchTerm = payload;
    },

    CLEAR_SEARCH_JOB_TERM(_state) {
      const state = _state;
      // Remove o termo buscado pelo usuario
      state.searchTerm = "";
    },

    SET_SUBSCRIPTIONS(_state, payload) {
      const state = _state;
      // Adiciona as inscricoes do state, mas antes verifica se ela ainda não existe
      payload.forEach((subscription) => {
        const exists = state.subscriptions.findIndex(
          (s) => s.id == subscription.id
        );

        if (exists == -1) {
          state.subscriptions.push(subscription);
        } else {
          state.subscriptions[exists] = subscription;
        }
      });
    },

    SET_SPECIFIC_SUBSCRIPTION(_state, payload) {
      const state = _state;
      if (!payload.opportunityId) return;
      const oldSubscriptions = state.subscriptions;
      // eslint-disable-next-line max-len
      const indexToReplace = oldSubscriptions.findIndex(
        (s) => s.opportunityId == payload.opportunityId
      );

      if (indexToReplace >= 0) {
        state.subscriptions[indexToReplace] = payload;
      }
    },

    CLEAR_SUBSCRIPTIONS(_state) {
      const state = _state;
      // Limpa state de inscricoes
      state.subscriptions = [];
    },

    SET_CURRENT_OPPORTUNITY(_state, payload) {
      const state = _state;
      state.currentOpportunity = payload;
    },
  },

  getters: {},

  actions: {
    setRIOpportunities({ dispatch }, obj = {}) {
      return dispatch("setOpportunities", {
        ...obj,
        internal_recruitment: true,
      });
    },

    setOpportunities({ commit, dispatch, rootState }, obj) {
      let params = "";
      // Pega o token contido no store da aplicacao root
      const header = { headers: { Authorization: rootState.tkn } };

      // Criamos alguns parametros de acordo com o objeto vindo
      if (obj && obj.internal_recruitment) {
        params += `&internal_recruitment=${obj.internal_recruitment}`;
      }
      if (obj && obj.page) {
        params += `&page=${obj.page}`;
      }
      if (obj && obj.collection) {
        params += `&collection=${obj.collection}`;
      }
      if (obj && obj.jobName) {
        params += `&q=${obj.jobName}`;
      }
      if (obj && obj.cities && obj.cities.length > 0) {
        params += `&city=${Vue.prototype.$helpers.cleanStringToCompare(
          obj.cities.join("&city=")
        )}`;
      }
      if (obj && obj.pcd) {
        params += `&pcd=${obj.pcd}`;
      }
      if (obj && obj.temporary) {
        params += `&temporary=${obj.temporary}`;
      }
      if (obj && obj.level && obj.level.length > 0) {
        params +=
          obj.level.constructor == Array
            ? `&level[]=${obj.level.join("&level[]=")}`
            : `&level=${obj.level}`;
      }
      if (obj && obj.filial) {
        params += `&filial=${obj.filial}`;
      }
      if (obj && obj.city) {
        params += `&city=${Vue.prototype.$helpers.cleanStringToCompare(
          obj.city
        )}`;
      }
      if (obj && obj.states) {
        params += `&states=${obj.states}`;
      }
      if (obj && obj.neighborhoods) {
        params += `&bairro=${obj.neighborhoods}`;
      }
      if (obj && obj.country) {
        params += `&country=${obj.country}`;
      }
      if (obj && obj.company_field_area && obj.company_field_area.length > 0) {
        params += `&company_field_area=${obj.company_field_area.join(",")}`;
      }
      if (obj && obj.company_area) {
        params += `&company_area=${obj.company_area}`;
      }
      if (
        obj &&
        obj.company_field_nivel &&
        obj.company_field_nivel.length > 0
      ) {
        params += `&company_field_nivel=${obj.company_field_nivel.join(",")}`;
      }
      if (obj && obj.order) {
        params += `&order=${obj.order}`;
      }
      if (obj && obj.zipcode) {
        params += `&zipcode=${obj.zipcode}`;
      }
      if (obj && obj.radius) {
        params += `&radius=${obj.radius}`;
      }

      return new Promise((resolve, reject) => {
        axios
          .get(
            `${Vue.prototype.OPPORTUNITIES_ENDPOINT}/v1/opportunities?${params}`,
            header
          )
          .then(
            (resp) => {
              const list = resp.data.opportunities;
              commit("ADD_OPPORTUNITY", list);

              setTimeout(() => {
                dispatch("subscriptionsWithPagination", {
                  page: obj && obj.page ? obj.page : 1,
                });
              }, 300);

              resolve(list);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    getOpportunity({ dispatch, commit, rootState }, id) {
      // Pega o token contido no store da aplicacao root
      const header = { headers: { Authorization: rootState.tkn } };

      return new Promise((resolve, reject) => {
        axios
          .get(
            `${Vue.prototype.OPPORTUNITIES_ENDPOINT}/v1/opportunities/${id}`,
            header
          )
          .then(
            (resp) => {
              const opportunity = resp.data.opportunity[0];

              if (opportunity) {
                const opportunitySlug =
                  opportunity.links.subscription.split("/");
                opportunity.slug = opportunitySlug[opportunitySlug.length - 1];
                dispatch("isEnrolled", { opportunityId: opportunity.id }).then(
                  (isEnrolled) => {
                    commit("SET_SUBSCRIPTIONS", isEnrolled);
                  }
                );
                commit("SET_CURRENT_OPPORTUNITY", opportunity);
              }

              resolve(opportunity);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    async getOpportunityAnyCompany({ dispatch, commit, rootState }, obj = {}) {
      let apiSession = Cookies.get('apiSession')
      if (apiSession) apiSession = JSON.parse(apiSession)
      const expiresIn = new Date(apiSession ? apiSession.expires_in : null)

      if (!apiSession || new Date() > expiresIn) {
        await dispatch('user/createSessionToken', {}, { root: true });
        apiSession = JSON.parse(Cookies.get('apiSession'))
      }

      const params = new URLSearchParams();
      params.append(
        "query",
        `
        query {
          opportunity(
            id: ${obj.opportunityId}
          )
          {
            id
            title
            slug
            level
            expiredAt
            actingMode
            cover
            responsability
            requirement
            status
            benefits {
              name
              icon
              category
            }
            otherBenefit
            descriptions {
              order
              data
            }
            company {
              id
              name
              slug
              logo
              score
              evaluationsCount
              pictures {
                originalFile
              }
            }
            opportunityTests {
              id
              name
              requiredIn
            }
            subscriptionQuestions {
              id
              title
              required
              candidate
              eliminatoryAswers
              eliminatoryQuestion
              eliminatoryTemplate
              hint
              htmlType
              inSubscription
              options
              order
              slug
            }
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(`${Vue.prototype.OPPORTUNITIES_GRAPHQL_ENDPOINT}/graphql`, params, {
            headers: { Authorization: apiSession.access_token },
          })
          .then(
            (resp) => {
              if (resp.data.data.opportunity) {
                let opportunity = resp.data.data.opportunity;

                // Como a API anterior (REST) usa snack_case, e a nova API (graphql) retorna em CamelCase, então fazemos uma conversão para não quebrar nada
                opportunity = Vue.prototype.$helpers.replaceCamelToSnakCase(opportunity);

                dispatch("isEnrolled", { opportunityId: opportunity.id }).then((isEnrolled) => {
                  commit("SET_SUBSCRIPTIONS", isEnrolled);
                });

                commit("SET_CURRENT_OPPORTUNITY", opportunity);

                resolve(opportunity);
              } else {
                resolve(null);
              }
            },
            (error) => {
              reject(error);
            },
          );
      });
    },

    isEnrolled({ rootState }, obj = {}) {
      if (!rootState.user.profile) return [];

      const params = new URLSearchParams();
      params.append(
        "query",
        `
        query {
          subscriptions(
            opportunityId: ${obj.opportunityId}
            userId: "${rootState.user.profile.id}",
          )
          {
            id,
            opportunityId
            step
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(`${Vue.prototype.API_ENDPOINT}/graphql`, params, {
            headers: { Authorization: rootState.tkn },
          })
          .then(
            (resp) => {
              const isEnrolled = resp.data.data.subscriptions;

              resolve(isEnrolled);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    getSubscriptions({ commit, rootState }, obj = {}) {
      if (!rootState.user.profile) return false;

      const params = new URLSearchParams();
      params.append(
        "query",
        `
        query {
          subscriptions(
            limit: 20,
            userId: "${rootState.user.profile.id}",
            companyId: ${obj.companyId || rootState.companyId},
            ${"onlyRI" in rootState
          ? ` internalRecruitment: "${rootState.onlyRI}" ,`
          : ""
        }
          )
          {
            id,
            opportunityId,
            slug,
            deletedAt,
            isDeleted,
            createdAt,
            opportunity {
              title,
              address {
                street,
                number,
                neighborhood,
                city,
                stateAbbr
              },
            }
            company {
              id
            }
            events {
              id
              opportunityId
              title
              date
              addressId
              address
              roomId
              room
              scheduleId
              schedule
              status
              confirmedAt
            }
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(`${Vue.prototype.API_ENDPOINT}/graphql`, params, {
            headers: { Authorization: rootState.tkn },
          })
          .then(
            (resp) => {
              const subscriptionsReturn = resp.data.data.subscriptions;

              commit("SET_SUBSCRIPTIONS", subscriptionsReturn);
              resolve();
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    subscriptionsWithPagination({ commit, rootState }, obj = {}) {
      if (!rootState.user.profile) return false;
      const params = new URLSearchParams();
      let getOnlineTests = "";

      if (obj.getOnlineTests) {
        getOnlineTests = `
          listTests {
            records,
            showMindsightQuestion,
            error
          }
        `;
      }

      params.append(
        "query",
        `
        query {
          subscriptionsWithPagination(
            companyId: ${obj.companyId || rootState.companyId},
            userId: "${rootState.user.profile.id}",
            limit: 20,
            page: ${obj.page || 1}
          ){
            records {
              id,
              opportunityId,
              slug,
              deletedAt,
              isDeleted,
              createdAt,
              step,
              opportunity {
                title,
                status,
                address {
                  street,
                  number,
                  neighborhood,
                  city,
                  stateAbbr
                },
              }
              company {
                id
              }
              events {
                id
                opportunityId
                title
                date
                addressId
                address
                roomId
                room
                scheduleId
                schedule
                status
                confirmedAt
              }
              ${getOnlineTests}
            },

            meta
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(`${Vue.prototype.API_ENDPOINT}/graphql`, params, {
            headers: { Authorization: rootState.tkn },
          })
          .then(
            (resp) => {
              const subscriptionsWithPagination =
                resp.data.data.subscriptionsWithPagination.records;
              commit("SET_SUBSCRIPTIONS", subscriptionsWithPagination);
              resolve(resp.data.data.subscriptionsWithPagination);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    subscriptionQuestions({ rootState }, id) {
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        query {
          subscriptionQuestions(
            opportunityId: "${id}"
          )
          {
            id,
            opportunityId,
            htmlType,
            title,
            hint,
            options,
            required,
            slug,
            candidate
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(`${Vue.prototype.API_ENDPOINT}/graphql`, params, {
            headers: { Authorization: rootState.tkn },
          })
          .then(
            (resp) => {
              const { subscriptionQuestions } = resp.data.data;

              resolve(subscriptionQuestions);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    listQuestionFiles({ rootState }, obj = {}) {
      const params = new URLSearchParams();
      params.append(
        "query",
        `
          query {
            listQuestionFiles(questionId: ${obj.questionId}) {
              id,
              name,
              file
            }
          }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(`${Vue.prototype.API_ENDPOINT}/graphql`, params, {
            headers: { Authorization: rootState.tkn },
          })
          .then(
            (resp) => {
              const { listQuestionFiles } = resp.data.data;
              resolve(listQuestionFiles);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    uploadFilesQuestion({ rootState }, obj = {}) {
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          uploadFilesQuestion(
            user_id: ${rootState.user.profile.id},
            question_id: ${obj.question_id},
            document_base64: "${obj.document_base64}",
            original_filename: "${obj.original_filename}"
          ){
            id
            file
            name
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(`${Vue.prototype.API_ENDPOINT}/graphql`, params, {
            headers: { Authorization: rootState.tkn },
          })
          .then(
            (resp) => {
              const { uploadFilesQuestion } = resp.data.data;
              resolve(uploadFilesQuestion);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    removeAttachedFile({ rootState }, obj = {}) {
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          removeAttachedFile(
            document_id:  ${obj.id},
          ){
            id
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(`${Vue.prototype.API_ENDPOINT}/graphql`, params, {
            headers: { Authorization: rootState.tkn },
          })
          .then(
            (resp) => {
              const removeAttachedFile = resp.data;
              resolve(removeAttachedFile);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    validateCandidateEliminatoryQuestions({ rootState }, obj = {}) {
      const params = new URLSearchParams();

      params.append(
        "query",
        `
        mutation {
          validateCandidateEliminatoryQuestions(
            opportunity_id: ${obj.opportunity_id},
            questions: [${obj.questions.map(
          (item) => `{
                id: "${JSON.stringify(item.id)}",
                question: ${JSON.stringify(item.title)},
                answer: ${JSON.stringify(item.answer.toString())},
                slug: ${JSON.stringify(item.slug)},
                candidate: "${JSON.stringify(item.candidate)}",
              }`
        )}],
          )
          {
            subscribe,
            template
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(`${Vue.prototype.API_ENDPOINT}/graphql`, params, {
            headers: { Authorization: rootState.tkn },
          })
          .then(
            (resp) => {
              const { validateCandidateEliminatoryQuestions } = resp.data.data;

              resolve(validateCandidateEliminatoryQuestions);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    subscriptionNew({ rootState }, _obj) {
      const obj = Vue.prototype.$helpers.removeSomeCaracters(_obj);
      const params = new URLSearchParams();

      const questions = obj.questions.map((q) => {
        let answer = "";

        if (Array.isArray(q.answer)) {
          answer = `${JSON.stringify(q.answer)}`;
        } else {
          answer = q.answer.toString();
        }

        return `{
          id: "${JSON.stringify(q.id)}",
          question: ${JSON.stringify(q.title)},
          answer: ${JSON.stringify(answer)},
          slug: ${JSON.stringify(q.slug)},
          candidate: "${JSON.stringify(q.candidate)}",
        }`;
      });

      params.append(
        "query",
        `
        mutation {
          subscriptionNew(
            opportunity_id: ${obj.opportunity_id},
            user_id: ${rootState.user.profile.id},
            source: "${obj.source || "companypage"}",
            ${obj.indication_form
          ? `indication: { name: "${obj.indication_form.name}", email: "${obj.indication_form.email}" }`
          : ""
        }
            origin_company: ${obj.companyId || rootState.companyId},
            questions: [${questions}],
            ${obj.send_confirmed_email
          ? ` send_confirmed_email: ${obj.send_confirmed_email} ,`
          : ""
        }
            ${obj.ignore_online_tests
          ? ` ignore_online_tests: ${obj.ignore_online_tests} ,`
          : ""
        }
          )
          {
            id
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(`${Vue.prototype.API_ENDPOINT}/graphql`, params, {
            headers: { Authorization: rootState.tkn },
          })
          .then(
            (resp) => {
              const subscriptionCreate = resp.data;

              resolve(subscriptionCreate);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    createAndIndexSubscriptionLead({ rootState }, obj = {}) {
      const params = new URLSearchParams();

      params.append(
        "query",
        `
        mutation {
          createAndIndexSubscriptionLead(
            opportunity_id: ${obj.opportunity_id},
            user_id: ${rootState.user.profile.id},
          )
          {
            id
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(`${Vue.prototype.API_ENDPOINT}/graphql`, params, {
            headers: { Authorization: rootState.tkn },
          })
          .then(
            (resp) => {
              const createAndIndexSubscriptionLead = resp.data;

              resolve(createAndIndexSubscriptionLead);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    subscriptionLogicalDelete({ rootState, commit }, obj = {}) {
      const params = new URLSearchParams();

      params.append(
        "query",
        `
        mutation {
          subscriptionLogicalDelete(
            subscription_id: "${obj.subscription_id}",
            user_id: ${rootState.user.profile.id},
            user_name: "${rootState.user.profile.name}"
          )
          {
            deletedAt,
            isDeleted
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(`${Vue.prototype.API_ENDPOINT}/graphql`, params, {
            headers: { Authorization: rootState.tkn },
          })
          .then(
            (resp) => {
              const response = resp.data;

              if (!response.error) {
                const { subscriptionLogicalDelete } = response.data;
                const currentSubscriptions =
                  rootState.opportunities.subscriptions;
                const foundIndex = currentSubscriptions.findIndex(
                  (x) => x.id == obj.subscription_id
                );

                currentSubscriptions[foundIndex].deletedAt =
                  subscriptionLogicalDelete.deletedAt;
                currentSubscriptions[foundIndex].isDeleted =
                  subscriptionLogicalDelete.isDeleted;
                commit("SET_SUBSCRIPTIONS", currentSubscriptions);
              }

              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    eligibleCandidate({ rootState }, obj = {}) {
      const params = new URLSearchParams();
      const eligibilities = Vue.prototype.eligibilities || {};

      // Se a elegibilidade já foi feita nessa sessão, ela está armazenada. é só devolver
      if (eligibilities && eligibilities[obj.opportunity_id]) {
        // return eligibilities[obj.opportunity_id];
      }

      // NENHUMA elegibilidade buscada por enquanto, setamos um objeto vazio
      if (Object.keys(eligibilities).length == 0) {
        // Vue.prototype.eligibilities = {};
      }

      params.append(
        "query",
        `
        query {
          eligibleCandidate(
            userId: 0,
            companyId: ${obj.companyId || rootState.companyId},
            opportunityId: ${obj.opportunityId},
          )
          {
            success,
            eligible,
            errorsEligibleCandidate
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(`${Vue.prototype.API_ENDPOINT}/graphql`, params, {
            headers: { Authorization: rootState.tkn },
          })
          .then(
            (resp) => {
              const eligibleResponse = resp.data;

              // if (!eligibleCandidate.error) {
              //   Vue.prototype.eligibilities[obj.opportunity_id] = eligibleCandidate;
              // }

              resolve(eligibleResponse);
            }, (error) => {
              reject(error);
            }
          )
          .catch((error) => {
            reject(error);
          });
      });
    },

    eligibilityItau({ rootState }, obj = {}) {
      const params = new URLSearchParams();
      const eligibilities = Vue.prototype.eligibilities || {};

      // Se a elegibilidade já foi feita nessa sessão, ela está armazenada. é só devolver
      if (eligibilities && eligibilities[obj.opportunity_id]) {
        return eligibilities[obj.opportunity_id];
      }

      // NENHUMA elegibilidade buscada por enquanto, setamos um objeto vazio
      if (Object.keys(eligibilities).length == 0) {
        Vue.prototype.eligibilities = {};
      }

      params.append(
        "query",
        `
        mutation {
          eligibilityItau(
            opportunity_id: "${obj.opportunity_id}",
            user_id: "${rootState.user.profile.id}",
            development: ${obj.development}
          )
          {
            eligible,
            messages
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(`${Vue.prototype.API_ENDPOINT}/graphql`, params, {
            headers: { Authorization: rootState.tkn },
          })
          .then(
            (resp) => {
              const eligibilityItau = resp.data;
              if (!eligibilityItau.error) {
                Vue.prototype.eligibilities[obj.opportunity_id] =
                  eligibilityItau;
              }

              resolve(eligibilityItau);
            },
            (error) => {
              reject(error);
            }
          )
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
